import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

export type TBulletBoxTone = "red" | "yellow" | "gray";

type TBulletBoxProps = {
  tone?: TBulletBoxTone;
  items: ReactNode[];
  className?: string;
};

const TONE_STYLES: Record<TBulletBoxTone, { bg: string; text: string; dot: string }> = {
  red: {
    bg: "bg-innoveraRed-50",
    text: "text-innoveraRed-700",
    dot: "bg-innoveraRed-700"
  },
  yellow: {
    bg: "bg-innoveraYellow-50",
    text: "text-innoveraYellow-700",
    dot: "bg-innoveraYellow-700"
  },
  gray: {
    bg: "bg-innoveraZinc-100",
    text: "text-innoveraZinc-400",
    dot: "bg-innoveraZinc-400"
  }
};

export function BulletBox({ tone = "red", items, className }: TBulletBoxProps) {
  const tones = TONE_STYLES[tone];
  return (
    <div
      className={cn(
        "flex w-full flex-col items-start gap-px rounded-[6px] px-[12px] py-[8px]",
        tones.bg,
        className
      )}
    >
      {items.map((item, index) => (
        <div key={index} className="flex w-full items-center gap-[10px]">
          <span className={cn("size-[4px] shrink-0 rounded-full", tones.dot)} />
          <p className={cn("min-w-0 flex-1 text-[14px] leading-[22px]", tones.text)}>{item}</p>
        </div>
      ))}
    </div>
  );
}
